<template>
    <div class="wrap d-flex flex-column">
        <router-view
            name="header"
            class="header shadow-sm"
        />
        <div
            v-cloak
            class="main d-flex h-100"
        >
            <router-view
                class="sidebar shadow-sm bg-dark-grey pb-8"
                name="sidebar"
            />
            <router-view class="content p-4 p-lg-5" />
            <PageLoader />
            <transition
                name="fade"
                mode="out-in"
            >
                <div
                    v-if="showArrow"
                    id="back-to-top"
                    @click="scrollToTop()"
                >
                    <span class="back-top-label">Back to top</span>
                    <SVGSprite name="up-arrow-angle" />
                </div>
            </transition>
        </div>
        <router-view
            name="footer"
            class="footer"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import common from 'js/mixins/common';
import SVGSprite from 'js/components/SVGSprite';
import PageLoader from './components/PageLoader';

export default {
    name: 'App',
    components: {
        PageLoader
    },
    mixins: [
        common
    ],
    data() {
        return {
            currentClass: '',
            scrolled: 0,
            windowSize: 0,
            showArrow: false,
            refreshUserInterval: ''
        };
    },
    computed: {
        ...mapState('user', ['authenticated'])
    },
    created() {
        this.$moment.locale('en-gb');
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('load', this.getWindowSize);
        window.removeEventListener('resize', this.getWindowSize);
    },
    mounted() {
        this.getGlobalConfig();

        // toggle body class
        this.toggleBodyClass('addClass');

        // show / hide back to top icon
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('load', this.getWindowSize);
        window.addEventListener('resize', this.getWindowSize);

        // refresh user every minute
        this.refreshUserInterval = setInterval(() => {
            if (this.authenticated) {
                this.refreshUser();
            }
        }, 60000);
    },
    beforeUpdate() {
        this.toggleBodyClass('removeClass');
    },
    updated() {
        this.toggleBodyClass('addClass');
    },
    methods: {
        ...mapActions('global', {
            getGlobalConfig: 'get'
        }),
        ...mapActions('user', [
            'refreshUser'
        ]),
        toggleBodyClass(addRemoveClass) {
            const el = document.body; // body dom element
            const routeName = this.$route.name; // name of route
            const pageClass = `page-${routeName}`; // create page class

            if (addRemoveClass === 'addClass') {
                this.currentClass = pageClass; // add current class to data object
                el.classList.add(pageClass); // add class to body
            }
            else {
                if (this.currentClass) {
                    el.classList.remove(this.currentClass); // if class exists, remove from body
                }
            }
        },
        getWindowSize() {
            this.windowSize = window.innerHeight;
        },
        handleScroll() {
            this.scrolled = window.scrollY;
            this.showArrow = (this.scrolled > this.windowSize);
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
};
</script>

<style lang="scss">
.wrap {
    height: 100%;
    min-height: 100vh;
}

.sidebar {
    overflow: auto;
}

.main {
    flex: 1;
}

.content {
    width: 100%;
    max-width: 1300px;
}

[v-cloak] > * {
    display: none;
}

[v-cloak] .js-loader {
    display: block !important;
}

#back-to-top {
    position: fixed;
    top: 0;
    left: 50%;
    margin: 1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    transform: translateX(-50%);
    color: white;
    background: theme-color('tertiary-hover');
    border-radius: 1rem;
    padding: .5rem 1.5rem;
    font-weight: bold;

    .back-top-label {
        display: inline-block;
        margin-right: 1rem;
    }

    .svg-sprite {
        svg {
            width: 15px;
            color: white;
        }
    }
}
</style>
